export const MuiMenu = {
	defaultProps: { disableScrollLock: true },
	styleOverrides: { list: { display: "flex", flexDirection: "column", gap: "4px", padding: "8px" } },
};
